import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {forkJoin} from 'rxjs';
import {saveAs} from 'file-saver';
import {AppSettings} from '../../../../../../proyect.conf';
import {TerceroUpPasarelaAdjuntoService} from '../../../../../_services/tercero-up-pasarela-adjunto.service';
import {TerceroUPPasarelaAdjunto} from '../../../../../_models/tercero-up-pasarela-adjunto';
import {AdministradorDocumentoService} from '../../../../../_services/administrador-documento.service';
import {AdministradorDocumento} from '../../../../../_models/administrador-documento';
import {AdjuntoService} from '../../../../../_services/adjunto.service';
import {NavService} from '../../../../../_services/_nav.service';
import {claseEstadoAdjunto, estadoAdjunto, filtrarPorTexto} from '../../admsb-titular.helpers';


@Component({
  selector: 'app-admsb-adjuntos-tabla',
  templateUrl: './admsb-adjuntos-tabla.component.html',
  styleUrls: ['./admsb-adjuntos-tabla.component.scss'],
})
export class AdmsbAdjuntosTablaComponent implements OnInit {

  /** Identificador de la pasarela del titular */
  @Input() idTitular: string;

  adjuntos: TerceroUPPasarelaAdjunto[] = [];
  cargandoAdjuntos = true;

  /** Texto del buscador de la tabla de adjuntos */
  filtroAdjuntos = '';

  /** URLs de subida de la tabla de adjuntos */
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  svcThUrlTercero = AppSettings.rutServiciosTER + '/api/adjuntosTerceros';

  /** idDocumentoTercero de las filas de la tabla que están subiendo un archivo */
  private adjuntosCargando = new Set<string>();
  subAdjunto = false;
  private nomArchivoAdjunto = '';

  /** Controla el modal de previsualización de un adjunto ya cargado */
  showModalAdjunto = false;
  loadingFile = false;
  fileUrl: SafeResourceUrl = null;
  private archivoAdjuntoVisor: Blob | null = null;
  private nombreArchivoAdjuntoVisor = '';
  adjuntoVisor: TerceroUPPasarelaAdjunto | null = null;

  /** Opciones del dropdown del modal "Agregar documento" */
  private documentosAdjuntos: SelectItem[] = [];

  /** Registros crudos del catálogo de documentos */
  private documentosAdjuntosCrudo: AdministradorDocumento[] = [];

  /** Documentos del catálogo aún no agregados a la tabla de adjuntos del titular */
  documentosDisponibles: SelectItem[] = [];

  /** Controla la visibilidad del modal "Agregar documento" */
  mostrarModalAgregarAdjunto = false;

  /** Controla la visualización del mensaje de validación del modal "Agregar documento" */
  submittedAdjunto = false;

  /** Evita el doble envío del modal "Agregar documento" mientras la solicitud está en curso */
  guardandoAdjunto = false;

  /** Documento seleccionado en el modal "Agregar documento" */
  idDocumentoAdjuntoSeleccionado: string | null = null;

  estadoAdjunto = estadoAdjunto;
  claseEstadoAdjunto = claseEstadoAdjunto;

  constructor(
    private administradorDocumentoService: AdministradorDocumentoService,
    private terceroUpPasarelaAdjuntoServicio: TerceroUpPasarelaAdjuntoService,
    private adjService: AdjuntoService,
    private sanitizer: DomSanitizer,
    private navService: NavService,
    private confirmService: ConfirmationService,
  ) {
  }

  ngOnInit(): void {
    this.administradorDocumentoService.getAllEnable().subscribe(res => {
      this.documentosAdjuntosCrudo = res;
      this.documentosAdjuntos = res.map((d: AdministradorDocumento) => ({label: d.nombre, value: d.idDocumentoTercero}));
      this.actualizarDocumentosDisponibles();
    });

    if (this.idTitular) {
      this.cargarAdjuntos(this.idTitular);
    } else {
      this.cargandoAdjuntos = false;
    }
  }

  private cargarAdjuntos(idTerceroUPPasarela: string): void {
    this.terceroUpPasarelaAdjuntoServicio.listAdjuntos(idTerceroUPPasarela).subscribe({
      next: res => {
        this.adjuntos = res;
        this.cargandoAdjuntos = false;
        this.actualizarDocumentosDisponibles();
      },
      error: () => this.cargandoAdjuntos = false,
    });
  }

  /**
   * Adjuntos filtrados según el texto del buscador
   */
  get adjuntosFiltrados(): TerceroUPPasarelaAdjunto[] {
    return filtrarPorTexto(this.adjuntos, this.filtroAdjuntos, [a => a.nombre, a => estadoAdjunto(a)]);
  }

  /**
   * Recalcula documentosDisponibles solo cuando cambian los datos de origen.
   */
  private actualizarDocumentosDisponibles(): void {
    const idsAgregados = new Set(this.adjuntos.map(a => a.idDocumentoTercero));
    this.documentosDisponibles = this.documentosAdjuntos.filter(d => !idsAgregados.has(d.value));
  }

  /** Indica si la fila del adjunto está subiendo un archivo */
  estaCargando(adjunto: TerceroUPPasarelaAdjunto): boolean {
    return this.adjuntosCargando.has(adjunto.idDocumentoTercero);
  }

  onSelectAdjunto(files: File[], adjunto: TerceroUPPasarelaAdjunto): void {
    this.adjuntosCargando.add(adjunto.idDocumentoTercero);
    this.nomArchivoAdjunto = files[0]?.name ?? '';
  }

  onBeforeSendAdjunto(event: any): void {
    this.subAdjunto = true;
    this.adjService.cargarArchivo(event, this.nomArchivoAdjunto, 'AdmsbTitularAdjuntos');
  }

  onUploadAdjunto(event: any, adjunto: TerceroUPPasarelaAdjunto): void {
    const idAdjunto = event?.originalEvent?.body?.idAdjunto;
    if (!idAdjunto) {
      this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
      this.subAdjunto = false;
      return;
    }
    this.terceroUpPasarelaAdjuntoServicio.crearAdjuntoVersion(this.construirRegistroAdjunto(adjunto, idAdjunto)).subscribe({
      next: () => {
        this.navService.setMesage(2);
        this.cargarAdjuntos(this.idTitular);
        this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
        this.subAdjunto = false;
        if (this.showModalAdjunto) {
          this.verAdjunto({...adjunto, idAdjunto});
        }
      },
      error: () => {
        this.navService.setMesage(3);
        this.adjuntosCargando.delete(adjunto.idDocumentoTercero);
        this.subAdjunto = false;
      },
    });
  }

  /**
   * Descarga el archivo del adjunto y abre el visor compartido en modo lectura.
   */
  verAdjunto(adjunto: TerceroUPPasarelaAdjunto): void {
    this.adjuntoVisor = adjunto;
    this.loadingFile = true;
    this.showModalAdjunto = true;
    forkJoin([
      this.adjService.descargarArchivo(adjunto.idAdjunto, adjunto.indicadorTercero),
      this.adjService.obtenerAdjunto(adjunto.idAdjunto, adjunto.indicadorTercero),
    ]).subscribe({
      next: ([archivo, infoAdjunto]) => {
        this.archivoAdjuntoVisor = archivo;
        this.nombreArchivoAdjuntoVisor = infoAdjunto.nombreArchivo;
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(archivo));
        this.loadingFile = false;
      },
      error: () => this.loadingFile = false,
    });
  }

  /**
   * Descarga a disco el archivo actualmente mostrado en el visor de adjuntos.
   */
  descargarArchivo(): void {
    if (!this.archivoAdjuntoVisor) {
      return;
    }
    saveAs(this.archivoAdjuntoVisor, this.nombreArchivoAdjuntoVisor || 'archivo');
  }

  cerrarModalAdjunto(): void {
    this.showModalAdjunto = false;
    this.fileUrl = null;
    this.archivoAdjuntoVisor = null;
    this.nombreArchivoAdjuntoVisor = '';
    this.adjuntoVisor = null;
  }

  eliminarAdjunto(adjunto: TerceroUPPasarelaAdjunto): void {
    this.confirmService.confirm({
      message: this.navService.buscarMensaje('MSG_INHABILITARAdjunto'),
      header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'admsb-adjuntos-modal',
      accept: () => {
        this.terceroUpPasarelaAdjuntoServicio.inhabilitarAdjunto(this.construirRegistroAdjunto(adjunto, null, false)).subscribe({
          next: () => {
            this.navService.setMesage(2);
            this.cargarAdjuntos(this.idTitular);
          },
          error: () => this.navService.setMesage(3),
        });
      },
    });
  }

  /**
   * Abre el modal "Agregar documento" reiniciando la selección previa.
   */
  abrirModalAgregarAdjunto(): void {
    this.submittedAdjunto = false;
    this.guardandoAdjunto = false;
    this.idDocumentoAdjuntoSeleccionado = null;
    this.mostrarModalAgregarAdjunto = true;
  }

  cerrarModalAgregarAdjunto(): void {
    this.mostrarModalAgregarAdjunto = false;
  }

  /**
   * Valida el campo obligatorio del modal "Agregar documento" y crea el nuevo adjunto para el titular.
   */
  guardarAdjunto(): void {
    this.submittedAdjunto = true;
    const doc = this.documentosAdjuntosCrudo.find(d => d.idDocumentoTercero === this.idDocumentoAdjuntoSeleccionado);
    if (!this.idDocumentoAdjuntoSeleccionado || !doc || this.guardandoAdjunto) {
      return;
    }

    this.guardandoAdjunto = true;
    this.terceroUpPasarelaAdjuntoServicio.crearAdjuntoVersion(this.construirRegistroAdjunto(doc, null)).subscribe({
      next: () => {
        this.navService.setMesage(2);
        this.cargarAdjuntos(this.idTitular);
        this.guardandoAdjunto = false;
        this.cerrarModalAgregarAdjunto();
      },
      error: () => {
        this.navService.setMesage(3);
        this.guardandoAdjunto = false;
      },
    });
  }

  /**
   * Body común de crearAdjuntoVersion/inhabilitarAdjunto. Cuando proviene de un adjunto ya existente
   * (editar/inhabilitar) incluye sus ids de pasarela y versión
   */
  private construirRegistroAdjunto(
    base: Pick<TerceroUPPasarelaAdjunto, 'idDocumentoTercero' | 'codigo' | 'nombre' | 'codigoTipoVigencia' |
      'tipoVigencia' | 'indicadorSolicitarCliente' | 'orden'> &
      Partial<Pick<TerceroUPPasarelaAdjunto, 'idTerceroUPPasarelaAdjunto' | 'idTercerosUPPasarelasAdjuntosVersion'>>,
    idAdjunto: string | null,
    indicadorHabilitado = true,
  ): Partial<TerceroUPPasarelaAdjunto> & { idtercerosUPPasarelasAdjuntos?: string; indicadorHabilitado?: boolean } {
    return {
      idTerceroUPPasarela: this.idTitular,
      idTerceroUPPasarelaAdjunto: base.idTerceroUPPasarelaAdjunto,
      idTercerosUPPasarelasAdjuntosVersion: base.idTercerosUPPasarelasAdjuntosVersion,
      idDocumentoTercero: base.idDocumentoTercero,
      codigo: base.codigo,
      nombre: base.nombre,
      codigoTipoVigencia: base.codigoTipoVigencia,
      tipoVigencia: base.tipoVigencia,
      indicadorSolicitarCliente: base.indicadorSolicitarCliente,
      orden: base.orden,
      idAdjunto,
      indicadorHabilitado,
    };
  }

}
